import {EsquireClient} from "@/types/clients/esquire";
import PutOfferResponse from "@/types/clients/esquire/responses/put-offer-response";
import PutResponse from "@/types/clients/esquire/responses/put-response";

export default class PutOfferRequest {
  constructor(private client: EsquireClient) {
  }

  public async send(offerData: PutOfferResponse): Promise<PutResponse> {
    const url = await this.client.fetchUrlFromSession("put-offer");

    const response = await this.client.fetch(
      () => new URL(url), {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: offerData.toJsonString()
      });

    await this.client.logOutIfForbidden(response.status);
    const responseData = await response.json();

    if (!response.ok) {
      return new PutResponse(responseData.message, response.status, responseData.identifier);
    }

    return new PutResponse(responseData.message, response.status, responseData.identifier);

  }
}
